var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('main',[_c('directus-article',{attrs:{"from":"id","getter":"4","showHeading":false}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }